import { CalendarIcon } from "@heroicons/react/24/outline";
import { isRsvpResponse, rsvpResponseLabels } from "@sp-crm/core";
import { defaultLinkStyle } from "components/ui/link";
import React from "react";
import { Link } from "react-router-dom";
import { EntityActivitySummary } from "./details/entity-activity-summary";
import { EntityActivityEntryProps } from "./types";

const responseLabel = (response: string | undefined): string =>
    isRsvpResponse(response) ? rsvpResponseLabels[response] : "Unknown";

export const EntityActivityEventRsvp: React.FC<EntityActivityEntryProps> = props => {
    const { activity } = props;
    const event = activity.activity.metadata?.events?.find(e => e.type === "EventRsvp");
    const eventTitle = event?.eventRsvp?.eventTitle;
    const eventId = event?.eventRsvp?.eventId;
    const note = event?.eventRsvp?.note;
    const rsvpSource = event?.eventRsvp?.rsvpSource;

    return (
        <div className="relative flex items-start space-x-3">
            <div className="relative px-1">
                <div className="flex h-8 w-8 items-center justify-center rounded-full bg-gray-100 ring-8 ring-white">
                    <CalendarIcon className="h-5 w-5 text-gray-500" aria-hidden="true" />
                </div>
            </div>
            <div className="min-w-0 flex-1 group pt-1">
                <EntityActivitySummary {...props}>
                    {rsvpSource === "advisor" ? "recorded an RSVP of " : "RSVP'd "}
                    &quot;{responseLabel(event?.eventRsvp?.response)}&quot;
                    {eventTitle ? (
                        <>
                            {" "}
                            to{" "}
                            {eventId ? (
                                <Link
                                    className={defaultLinkStyle}
                                    to={`/events/${eventId}`}>
                                    {eventTitle}
                                </Link>
                            ) : (
                                <strong>{eventTitle}</strong>
                            )}
                        </>
                    ) : null}
                    .{note ? <div className="text-gray-500 italic">{note}</div> : null}
                </EntityActivitySummary>
            </div>
        </div>
    );
};
